import {
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  Dimensions,
} from "react-native";
import React, { useState } from "react";
import AppColors from "../../Constants/AppColors";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";
import DeliveryActive from "./DeliveryActive";
import DeliveryHistory from "./DeliveryHistory";

const { width } = Dimensions.get("window");

// Custom Tab Component
const CustomTab = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: "active", label: "Active" },
    { id: "history", label: "History" },
  ];

  const t = (key) => {
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }
    return key;
  };

  return (
    <View style={styles.tabContainer}>
      <View style={styles.tabBar}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <TouchableOpacity
              key={tab.id}
              style={[styles.tabButton, isActive && styles.activeTabButton]}
              onPress={() => onTabChange(tab.id)}
              activeOpacity={0.7}
            >
              <Text style={[styles.tabText, isActive && styles.activeTabText]}>
                {t(`common:translation.${tab.label}`)}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
      {/* Animated Indicator */}
      <View style={styles.indicatorContainer}>
        <View
          style={[
            styles.indicator,
            {
              transform: [
                {
                  translateX:
                    ((width - 40) / tabs.length) *
                    tabs.findIndex((t) => t.id === activeTab),
                },
              ],
            },
          ]}
        />
      </View>
    </View>
  );
};

const Delivery = ({ navigation }) => {
  const [activeTab, setActiveTab] = useState("active");

  const t = (key, options = {}) => {
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }
    return key;
  };

  const renderContent = () => {
    switch (activeTab) {
      case "active":
        return <DeliveryActive />;
      case "history":
        return <DeliveryHistory />;
      default:
        return <DeliveryActive />;
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      {/* Header */}
      <View style={styles.header}>
        <View style={styles.headerLeft}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image source={AppImages.Backbtn} style={styles.backIcon} />
          </TouchableOpacity>
          <Text style={styles.headerTitle}>
            {t("common:translation.Delivery Person")}
          </Text>
        </View>

        <View style={styles.headerRight}>
          <TouchableOpacity
            style={styles.iconButton}
            onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}
          >
            <Image
              source={AppImages.Bellnoti}
              style={styles.notificationIcon}
              resizeMode="contain"
            />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.iconButton}
            onPress={() => navigation.navigate("AddDeliveryperson")}
          >
            <Image
              source={AppImages.Plus}
              style={styles.plusIcon}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>

      {/* Custom Tabs */}
      <View style={styles.contentContainer}>
        <CustomTab activeTab={activeTab} onTabChange={setActiveTab} />
        <View style={styles.tabContent}>{renderContent()}</View>
      </View>
    </SafeAreaView>
  );
};

export default Delivery;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: AppColors.sandal,
  },
  header: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: AppColors.white,
    height: 58,
    justifyContent: "space-between",
    paddingHorizontal: 20,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 5,
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
  },
  backButton: {
    height: 30,
    width: 30,
    justifyContent: "center",
  },
  backIcon: {
    width: 8,
    height: 15,
  },
  headerTitle: {
    fontSize: 16,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
    marginLeft: 15,
  },
  headerRight: {
    flexDirection: "row",
    alignItems: "center",
  },
  iconButton: {
    padding: 5,
  },
  notificationIcon: {
    width: 16,
    height: 20,
  },
  plusIcon: {
    width: 18,
    height: 18,
    marginLeft: 15,
  },
  contentContainer: {
    flex: 1,
    marginTop: 20,
  },
  tabContainer: {
    paddingHorizontal: 20,
    marginBottom: 10,
  },
  tabBar: {
    flexDirection: "row",
    backgroundColor: "#F5E6D8", // Light sandal color
    borderRadius: 10,
    padding: 4,
  },
  tabButton: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 12,
    borderRadius: 8,
  },
  activeTabButton: {
    backgroundColor: AppColors.white,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 3,
  },
  tabText: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: "#9C4900CC",
    textTransform: "none",
  },
  activeTabText: {
    fontFamily: AppFonts.OverpassBold,
    color: "#8F4300",
  },
  indicatorContainer: {
    height: 3,
    marginTop: 8,
    overflow: "hidden",
  },
  indicator: {
    width: (width - 40) / 2, // 2 tabs, minus horizontal padding
    height: 3,
    backgroundColor: "#8F4300",
    borderRadius: 1.5,
    position: "absolute",
  },
  tabContent: {
    flex: 1,
  },
});
